/**
 * Convert a number of seconds into a human-readable duration.
 *
 * Default output examples:
 *  - 65   -> "1:05"
 *  - 3605 -> "1:00:05"
 *
 * With { style: 'long' }:
 *  - 65   -> "1m 05s"
 *  - 3605 -> "1h 00m 05s"
 *
 * @param {number|string|null|undefined} totalSeconds - Total seconds to format. Non-numeric values return an empty string.
 * @param {{ style?: 'default' | 'long', forceHours?: boolean }} [options]
 * @returns {string} Formatted duration string.
 */
export function formatDuration(totalSeconds, options = {}) {
  const { style = 'default', forceHours = false } = options;

  if (totalSeconds === null || totalSeconds === undefined) return '';

  const numericSeconds = Number(totalSeconds);
  if (Number.isNaN(numericSeconds) || !Number.isFinite(numericSeconds)) return '';

  if (numericSeconds <= 0) {
    return style === 'long' ? (forceHours ? '0h 00m 00s' : '0m 00s') : (forceHours ? '0:00:00' : '0:00');
  }

  // Use floor to avoid showing the next second prematurely
  const total = Math.floor(numericSeconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;

  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');

  if (style === 'long') {
    if (hours > 0 || forceHours) {
      return `${hours}h ${mm}m ${ss}s`;
    }
    return `${minutes}m ${ss}s`;
  }

  // default style
  if (hours > 0 || forceHours) {
    const hh = String(hours);
    return `${hh}:${mm}:${ss}`;
  }
  return `${minutes}:${ss}`;
}

export default formatDuration;
